import { UserPrivateAccountStorage } from "../storage";

export class UserPrivateAccountSubscriptionsModel {
  static instance;

  constructor() {
    if (UserPrivateAccountSubscriptionsModel.instance) {
      throw new Error('Clase singleton')
    }
    this.storage = UserPrivateAccountStorage.getInstance();
  }

  static getInstance() {
    if (!UserPrivateAccountSubscriptionsModel.instance) {
      UserPrivateAccountSubscriptionsModel.instance = new UserPrivateAccountSubscriptionsModel();
    }
    return UserPrivateAccountSubscriptionsModel.instance;
  }

  // DONE: Debe devolver plan y estado de mercado pago.
  getStatus() {
    return new Promise((resolve, reject) => {
      APICRUD.MercadoPago.Subscriptions.GetStatus()
        .then((status) => {
          this.storage.planSave(status);
          resolve(status);
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  getMPStatus() {
    return APICRUD.MercadoPago.Subscriptions.GetStatusFromMercadoPago();
  }

  changePlan(_idcod) {
    return APICRUD.MercadoPago.Subscriptions.ChangePlan(_idcod);
  }

  cancelPlan() {
    return APICRUD.MercadoPago.Subscriptions.Cancel();
  }

  /* DONE: Pedir al backend el cambio de plan. EL back debe analizar si el plan es gratuito (costo cero)
      En caso de:
        - Elegir gratuito: 
          - Back Implementacion MP:
            - Si tenia plan, ir a mercadolibre y pausar.
            - Actualizar la base de datos.
            - Devolver el OK.
          - Back APICRUD:
            - Devolver mensaje.
          - APICRUD Framework:
            - Devolver mensaje.
          - Agrolabores 
            - Pedir datos de suscripcion.
            - Actualizar cache de suscripcion.
            - Reiniciar ventana.
        - Elegir de pago: 
          - Si tenia plan, comparar que no sea el mismo.
            - Es el mismo: informar el KO.
            - No es el mismo: continuar proceso.
          - Back Implementacion MP:
            - Si tenia plan, ir a mercadolibre y cambiar.
            - Actualizar la base de datos.
            - Devolver el OK.
          - Back APICRUD:
            - Devolver mensaje.
          - APICRUD Framework:
            - Devolver mensaje.
          - Agrolabores 
            - Pedir datos de suscripcion.
            - Actualizar cache de suscripcion.
            - Reiniciar ventana.
  */
}
